import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';

const UserFormModal = ({ open, mode, initialValues, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue(
        initialValues || {
          username: '',
          password: '',
          role: 'user',
          displayName: '',
          bio: '',
          location: '',
          gender: '',
          is_active: true,
        }
      );
    }
  }, [open, initialValues, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    onSubmit(values);
  };

  return (
    <Modal
      title={mode === 'create' ? 'Создать пользователя' : 'Редактировать пользователя'}
      open={open}
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item name="username" label="Логин" rules={[{ required: true }]}>
          <Input disabled={mode === 'edit'} />
        </Form.Item>
        {mode === 'create' && (
          <Form.Item name="password" label="Пароль" rules={[{ required: true }, { min: 4, message: 'Минимум 4 символа' }]}>
            <Input.Password />
          </Form.Item>
        )}
        <Form.Item name="role" label="Роль">
          <Select
            options={[
              { value: 'user', label: 'Пользователь' },
              { value: 'manager', label: 'Руководитель' },
              { value: 'admin', label: 'Администратор' },
            ]}
          />
        </Form.Item>
        <Form.Item name="is_active" label="Активен">
          <Select
            options={[
              { value: true, label: 'Да' },
              { value: false, label: 'Нет' },
            ]}
          />
        </Form.Item>
        <Form.Item name="displayName" label="Отображаемое имя">
          <Input />
        </Form.Item>
        <Form.Item name="bio" label="О себе">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item name="location" label="Город">
          <Input />
        </Form.Item>
        <Form.Item name="gender" label="Пол">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UserFormModal;
